export default (path, queryString) => {
  if (queryString.includes('trk_location=careersBreadcrumb')) {
    if (queryString.includes('gh_src=') || queryString.includes('gh_jid=')) {
      // remove careersBreadcrumb trk_location from query string if already present
      if (queryString.includes('?careersBreadcrumb')) {
        return (
          path + queryString.replace('?trk_location=careersBreadcrumb', '')
        );
      }
      return path + queryString.replace('&trk_location=careersBreadcrumb', '');
    }
    return path;
  }
  if (queryString.includes('gh_src=') || queryString.includes('gh_jid=')) {
    return path + queryString;
  }
  return path;
};
